module.exports = __webpack_public_path__ + "img/inquiry.3144e217.svg";